import React, { useRef } from "react";

import { Map } from "leaflet";
import { MapContainer, TileLayer } from "react-leaflet";
import ProductItemMapContent from "./components/ProductItemMapContent";
import { DEFAULT_HEIGHT } from "./editor/ProductItemMapEditor";
import { ProductItemMapProps } from "./types";

export default function ProductItemMap(props: ProductItemMapProps) {
  const mapRef = useRef<Map | null>(null);
  return (
    <div className="relative">
      <MapContainer
        id="map"
        scrollWheelZoom
        doubleClickZoom={false}
        zoomControl={false}
        ref={mapRef}
        maxZoom={18}
        minZoom={7}
        className="mt-2"
        style={{ height: `${props.height ?? DEFAULT_HEIGHT}px` }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <ProductItemMapContent {...props} />
      </MapContainer>
    </div>
  );
}
